import script from "./SetSignatureModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SetSignatureModal.vue?vue&type=script&setup=true&lang=js"

import "./SetSignatureModal.vue?vue&type=style&index=0&id=58b7e852&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b7e852"]])

export default __exports__